import { render, staticRenderFns } from "./TamperHistoryList.vue?vue&type=template&id=1a04b1cf&scoped=true"
import script from "./TamperHistoryList.vue?vue&type=script&lang=js"
export * from "./TamperHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a04b1cf",
  null
  
)

export default component.exports